(function () {
  const selectTab = (root, index) => {
    const tabs = [...root.querySelectorAll('[data-heat-tab]')];
    const panels = [...root.querySelectorAll('[data-heat-panel]')];
    tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;
      panel.hidden = !active;
      if (active) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
    });
  };

  const init = (root) => {
    if (!root || root.dataset.heatReady === 'true') return;
    const tabs = [...root.querySelectorAll('[data-heat-tab]')];
    if (!tabs.length) return;
    root.dataset.heatReady = 'true';
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(root, index));
      tab.addEventListener('keydown', (event) => {
        const last = tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        selectTab(root, next);
        tabs[next].focus();
      });
    });
  };

  const boot = (scope) => {
    const context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-baselayer-heat]').forEach(init);
    if (context.matches && context.matches('[data-baselayer-heat]')) init(context);
  };

  const onReady = () => {
    boot(document);
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-heat-panel]');
      if (!panel) return;
      const root = panel.closest('[data-baselayer-heat]');
      if (!root) return;
      const panels = [...root.querySelectorAll('[data-heat-panel]')];
      const index = panels.indexOf(panel);
      if (index >= 0) selectTab(root, index);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
